<template>
  <!-- eslint-disable-next-line vue/require-component-is -->
  <component :is="tag" :class="classes" v-bind="$attrs" v-on="$listeners"><slot /></component>
</template>

<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { getColorScheme } from '~/modules/common/utils/componentUtils';

export default defineComponent({
  props: {
    variant: {
      type: String,
      default: 'solid',
    },
    colorScheme: {
      type: String,
      default: 'gray',
    },
    size: {
      type: String,
      default: 'base',
    },
    pure: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { attrs }) {
    const baseClasses = 'cursor-pointer transition-colors ease-out duration-200';

    const variants = {
      solid: 'rounded border-2 focus:outline-none focus:ring',
      outline: 'rounded border-2 focus:outline-none focus:ring',
      ghost: 'rounded border-2 focus:outline-none focus:ring',
      link: 'rounded hover:underline focus:outline-none focus:underline',
      pure: 'focus:outline-none',
    };

    const colorSchemes = {
      gray: {
        default: 'bg-transparent border-transparent',
        solid: 'bg-alpha-60 hover:bg-alpha-80 text-white border-transparent',
        ghost: 'bg-transparent border-transparent hover:bg-alpha-10  ',
        outline: 'border-divider-200 hover:bg-alpha-10',
      },
      red: {
        solid: 'bg-o-red hover:bg-red-600 text-white border-transparent',
        ghost: 'text-o-red bg-transparent border-transparent hover:bg-red-100',
        outline: 'text-o-red border-red-400 hover:bg-red-100 ',
        link: 'text-o-red',
      },
      green: {
        solid: 'bg-o-green hover:bg-green-600 text-white border-transparent',
        ghost: 'text-o-green bg-transparent border-transparent hover:bg-green-100',
        outline: 'text-o-green border-green-400 hover:bg-green-100 ',
        link: 'text-o-green',
      },
      blue: {
        solid: 'bg-o-blue hover:bg-blue-600 text-white border-transparent',
        ghost: 'text-o-blue bg-transparent border-transparent hover:bg-blue-100',
        outline: 'text-o-blue border-blue-400 hover:bg-blue-100 ',
        link: 'text-o-blue',
      },
      pure: '',
    };

    const sizes = {
      lg: 'px-6 py-3',
      md: 'px-5 py-2',
      base: 'px-4 py-2',
      sm: 'px-3 py-1.5',
      xs: 'px-2 py-1',
      pure: '',
    };

    const classes = computed(() => {
      const selectedSize = props.pure ? sizes.pure : sizes[props.size];
      const selectedVariant = props.pure ? variants.pure : variants[props.variant];
      const selectedColor = props.pure ? colorSchemes.pure : getColorScheme(props.colorScheme, props.variant, colorSchemes);
      return [baseClasses, selectedVariant, selectedSize, selectedColor].filter(Boolean).join(' ');
    });

    const tag = ref('button');
    // href var ise butonu anchor tag yap
    if (attrs.href) {
      tag.value = 'a';
    }

    return {
      tag,
      classes,
    };
  },
});
</script>

<style></style>
